import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Image,
  Text,
  Link,
  VStack,
  Button,
  Select,
  CloseIcon,
  Flex,
} from "native-base";
import { useNavigate } from "react-router-dom";
import StyledButton from "../components/Button";
import { useLocation } from "react-router-dom";
import { getDocument } from "..//utils/firebase/getDoc";
import { filterDataByPage } from "..//utils";
import { COLLECTION, DESKTOPSIZE, PAGETYPE } from "../constants";
import StyledDropdown from "../components/Dropdown";
import { dispatchAnalyticsEvent, dispatchAnalyticsPageView } from "../utils";
import { AppContext } from "../context";
import { ORG_ID } from "../constants/index";
import StyledImage from "../components/Image";
import { decryptDigitalId } from "../utils/decryptId";
import useCurrentLocation from "../hooks/useCurrentLocation";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import Tailor from '../images/needles.png'
import YourLocation from '../images/person.png'
import L from "leaflet";

import "./repair.css";

const addresses = [
  { lng: -73.95172804907455, lat: 40.773502435822465, name: "Ban Custom Tailor" },
  { lng: -77.08992427301506, lat: 38.98659501272521, name: "Rose Custom Tailor" },
  { lng: -118.37601183558205, lat: 34.08681955179167, name: "Ella's House of Tailoring" },

  { lng: -73.9967118644201, lat: 40.74248103875659, name: "Luigi's Quality Tailoring-Men" },
  { lng: -73.97673588095482, lat: 40.763450357171216, name: "LeatherSpa" },
  { lng: -74.00851581164157, lat: 40.71045026358138, name: "LeatherSpa" },

  { lng: -73.96524090674625, lat: 40.714923236168154, name: "Brooklyn Denim Co." },
  { lng: -118.36669438851203, lat: 34.072644336802874, name: "Hans the Tailor" },
];
const customIcon = L.icon({
  iconUrl: Tailor,
  iconSize: [38, 95],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76],
});
const userLocationIcon = L.icon({
  iconUrl: YourLocation,
  iconSize: [38, 95], 
  iconAnchor: [19, 47], 
  popupAnchor: [1, -34], 
});
const fallbackLocation = { lat: 51.505, lng: -0.09 };
const defaultZoom = 13; // Default zoom level
const zoomInLevel = 17; // Zoom level when focusing on user's location




function DressThreeRepair() {
  var manufacImage = require("../images/dressThreeRepair.png");
  const [service, setService] = React.useState("");
  const location = useLocation();
  const [getTheme, setTheme] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const orgId = queryParams.get("orgId");
  const encrypetdDigitalId = queryParams.get("digitalId");
  const digitalId = decryptDigitalId(encrypetdDigitalId);
  const styleId = queryParams.get("styleId");
  const lang = queryParams.get("lang");
  const style = queryParams.get("style");
  const Amarezza1 = require("../images/amarezza/Amarezza1.png");
  const [mapCenter, setMapCenter] = useState(fallbackLocation);
  const [mapZoom, setMapZoom] = useState(defaultZoom);
  const { currentLocation, error, isFetching } = useCurrentLocation();
  const center = error || !currentLocation ? fallbackLocation : currentLocation;
  const [showMap, setShowMap] = useState(false);
  const [closestLocations, setClosestLocations] = useState([]);

  const { getData, getParams } = useContext(AppContext);
  const currentURL = window.location.href;
  // Use the URL constructor to parse the URL
  const urlObj = new URL(currentURL);

  // Extract the "la-makanerie" value from the pathname
  const pathnameParts = urlObj.pathname.split("/");
  const [getPageData, setPageData] = useState(null);

  const fetchCountryFromCoordinates = async (lat, lng) => {

    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`);
      if (!response.ok) throw new Error('Failed to fetch country information');
      const data = await response.json();
      return data.address.country; // Assuming the API returns an 'address' object with a 'country' field
    } catch (error) {
      console.error('Error fetching country information:', error);
      return null;
    }
  };

    // Helper function to calculate distance
    function getDistance(lat1, lng1, lat2, lng2) {
      const toRad = x => (x * Math.PI) / 180;
      const R = 6371; // Radius of the earth in km
      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in km
    }
  
    // Determine the two closest locations
    useEffect(() => {
      if (currentLocation) {
        const distances = addresses.map(address => ({
          ...address,
          distance: getDistance(currentLocation.lat, currentLocation.lng, address.lat, address.lng),
        }));
  
        const sortedByDistance = distances.sort((a, b) => a.distance - b.distance);
        setClosestLocations(sortedByDistance.slice(0, 2));
      }
    }, [currentLocation]);

  useEffect(() => {
    if (!isFetching && !error && currentLocation) {
      setMapCenter(currentLocation); // Update center only if current location is available
      setMapZoom(zoomInLevel); // Zoom in closer
    }
  }, [currentLocation, error, isFetching]);

  // Determine if the map should be shown based on the country
  useEffect(() => {
    const allowedCountries = ['Sri Lanka', 'Denmark', 'United States'];
    if (currentLocation) {
      fetchCountryFromCoordinates(currentLocation?.lat, currentLocation?.lng).then(country => {
        if (allowedCountries.includes(country)) {
          setShowMap(true);
        } else {
          setShowMap(false);
        }
      }); 
    
    }
  }, [currentLocation]);

  useEffect(() => {
    dispatchAnalyticsPageView(location.pathname, PAGETYPE.repair);
    setPageData(
      filterDataByPage(
        getData,
        getParams.styleId,
        getParams.lang,
        PAGETYPE.repair
      )
    );

    // setTheme(filterDataByPage( getData, getParams.styleId, getParams.lang));
  }, [getData]);

  const navigate = useNavigate();
  return (
    <>
      {getPageData && (
        <>
          <Flex
            minH={"100vh"}
            direction="column"
            justifyContent={"space-between"}
          >
            <Box>
              <VStack
                alignItems="flex-start"
                space={4}
                px={"4"}
                paddingTop={"4"}
              >
                {/* <Link href="/la-makanerie/acqua/digitaID/acq0001"> */}
                <Button onPress={() => navigate(-1)} variant={"unstyled"}>
                  <CloseIcon
                    color={
                      getParams.style === "acqua"
                        ? "#B03D01"
                        : getParams.style === "amarezza"
                        ? "#DCA459D0"
                        : getPageData?.theme?.color?.primary
                    }
                    size={"5"}
                  />
                </Button>
                {/* </Link> */}
              </VStack>
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Text
                  color={getPageData?.theme?.color?.primary}
                  fontFamily={getPageData?.theme?.fontFamily?.secondary}
                  fontSize={getPageData?.theme?.fontSize?.xl}
                  letterSpacing={"0.46px"}
                >
                  {getPageData?.data?.title}
                </Text>
                <Text
                  color={getPageData?.theme?.color?.primary}
                  fontFamily={getPageData?.theme?.fontFamily?.secondary}
                  fontSize={getPageData?.theme?.fontSize?.large}
                  textAlign={"center"}
                >
                  {getPageData?.data?.description}
                </Text>
              </VStack>
              {/* <VStack
               marginBottom={"4"}
               alignItems={window.innerWidth > DESKTOPSIZE ? "center" : ""}
               px={4}
               space={"6"}
             >
               <Text
             color={getPageData?.theme?.color?.primary}
               fontFamily={getPageData.theme.fontFamily?.primary}
               fontSize={getPageData.theme.fontSize?.small}
            >
                 {getPageData.data.options}
               </Text>
             </VStack> */}
              <VStack
                alignItems={"center"}
                marginBottom={"4"}
                px={4}
                space={"6"}
              >
                <Select
                  selectedValue={service}
                  minWidth="200"
                  width="80"
                  accessibilityLabel={
                    pathnameParts[1] === "a-new-sweden"
                      ? "Select an option"
                      : "Sélectionnez une option"
                  }
                  placeholder={
                    pathnameParts[1] === "a-new-sweden"
                      ? "Select an option"
                      : "Sélectionnez une option"
                  }
                  mt={1}
                  onValueChange={(itemValue) => setService(itemValue)}
                  _selectedItem={{
                    bg: getPageData?.theme?.color?.primary,
                    color: "#1341B6", // Set selected item text color
                    _text: {
                      // Ensure the text color is applied if your component structure requires
                      color: "#1341B6",
                    },
                  }}
                  _focus={{
                    borderColor: "#1341B6", // Border color when focused
                    background: "white", // Background color when focused
                  }}
                  style={{
                    borderColor: service ? "#1341B6" : "initial", // Change border color if a service is selected
                    borderWidth: service ? "2px" : "1px",
                  }}
                >
                  <Select.Item
                    label={
                      pathnameParts[1] === "a-new-sweden"
                        ? "To modify"
                        : "Modifier"
                    }
                    value="modify"
                  />
                  <Select.Item
                    label={
                      pathnameParts[1] === "a-new-sweden" ? "Fix" : "Réparer"
                    }
                    value="repair"
                  />
                </Select>
              </VStack>

              {getPageData?.data.sections.map((section, index) => (
                <VStack
                  key={index}
                  alignItems={"center"}
                  px={4}
                  space={"4"}
                  py={"4"}
                >
                  <Text
                    color={getPageData?.theme?.color?.primary}
                    lineHeight={"20px"}
                    fontSize={getPageData?.theme?.fontSize?.medium}
                    fontWeight={getPageData?.theme?.fontWeight?.light}
                    fontFamily={getPageData?.theme?.fontFamily.primary}
                  >
                    {section?.title}
                  </Text>
                </VStack>
              ))}


    <VStack
      alignContent={"center"}
      justifyContent={"center"}
      px={4}
      space={"4"}
      marginTop={"8px"}
    >

     <MapContainer
        center={mapCenter}
        zoom={mapZoom}
        style={{ height: "500px", width: "500px", margin: "auto" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {currentLocation && (
          <Marker position={[currentLocation.lat, currentLocation.lng]} icon={userLocationIcon}>
            <Popup>You are here</Popup>
          </Marker>
        )}
         {closestLocations.map((location, index) => (
                <Marker key={index} position={[location.lat, location.lng]} icon={customIcon}
                eventHandlers={{
                  click: () => {
                    const mapLink = `http://maps.google.com/maps?daddr=${location.lat},${location.lng}&amp;ll=`;
                    window.open(mapLink);
                  },
                }}
                
                >
                  <Popup>{location.name}</Popup>
                </Marker>
              ))}
        {/* {addresses.map((address, index) => (
          <Marker
            key={index}
            position={[address.lat, address.lng]}
            icon={customIcon}
            eventHandlers={{
              click: () => {
                const mapLink = `http://maps.google.com/maps?daddr=${address.lat},${address.lng}&amp;ll=`;
                window.open(mapLink);
              },
            }}
          >
            <Popup>{address.name}</Popup>
          </Marker>
        ))} */}
      </MapContainer> 
    </VStack>
 

              <VStack
                alignItems={"center"}
                px={4}
                space={"4"}
                marginTop={pathnameParts[1] === "la-makanerie" ? "24px" : "0px"}
              >
                <Link
                  href="https://tilli.fr/reserver-votre-couturier-a-domicile/"
                  width={window.innerWidth > DESKTOPSIZE ? "40%" : "100%"}
                >
                  <StyledButton
                    text={getPageData.data.actions.btn_appointment}
                    backgroundColor={
                      style === "acqua"
                        ? "#B03D01"
                        : style === "amarezza"
                        ? "#DCA459"
                        : getPageData?.theme?.color?.primary
                    }
                    textColor="#FFFFFF"
                    borderColor="transparent"
                    width="100%"
                    height="54px"
                    hoverBackgroundColor="#FFFFFF"
                    hoverTextColor={
                      style === "acqua"
                        ? "#B03D01"
                        : style === "amarezza"
                        ? "#DCA459"
                        : getPageData?.theme?.color?.primary
                    }
                    hoverBorderColor={
                      style === "acqua"
                        ? "#B03D01"
                        : style === "amarezza"
                        ? "#DCA459"
                        : getPageData?.theme?.color?.primary
                    }
                  />
                </Link>
              </VStack>
            </Box>
            <VStack alignItems={"center"} marginTop={4}>
              <StyledImage
                width="40%"
                src={
                  style === "amarezza"
                    ? Amarezza1
                    : getPageData.data.images.primary
                }
                alt={"Image of the product design 2"}
              />
            </VStack>
          </Flex>
        </>
      )}
    </>
  );
}

export default DressThreeRepair;
